import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            {/* Brand */}
            <div className="footer-section footer-brand">
              <div className="footer-logo">
                <img src="/logo.png" alt="G.A.D. Logo" className="footer-logo-img" />
              </div>
              <p className="footer-about">
                Certified manufacturer of Electrical contact Rivets & assemblies <span> • </span> Proprietorship firm <span> • </span> <br /> since 1988.
              </p>
              <div className="footer-social">
                <a href="https://www.linkedin.com/company/g.a.d.-electrical-industries/" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="LinkedIn">in</a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 className="footer-heading">Electrical Contact Solutions</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/products?category=silver-contacts">
                    Solid Silver Contact Rivets
                  </Link>
                </li>
                <li>
                  <Link to="/products?category=bimetal-contacts">
                    Bimetal Contact Rivets
                  </Link>
                </li>
                <li>
                  <Link to="/products?category=clad-strips">
                    Silver Inlay & Clad Strips
                  </Link>
                </li>
                <li>
                  <Link to="/products?category=custom-oem">
                    Custom Contact Components
                  </Link>
                </li>
                <li>
                  <Link to="/products">
                    OEM Engineering Support
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h4 className="footer-heading">Contact Us</h4>
              <div className="footer-contact-list">
                <div className="footer-contact-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-location-dot"></i>
                  </div>
                  <span> B-97D, 2nd Floor  <br /> Mayapuri Industrial Area Phase-1 <br /> New Delhi 110064, India</span>
                </div>
                <div className="footer-contact-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <a href="tel:+911234567890">+91 1141254770</a>
                </div>
                <div className="footer-contact-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <a href="mailto:info.gadelectricalindustries@gmail.com">info.gadelectricalindustries@gmail.com</a>
                </div>
                <div className="footer-contact-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <span>Mon – Sat: 9:00 AM – 6:00 PM</span>
                </div>
              </div>
            </div>


            <div className="footer-section">
              <h4 className="footer-heading">Follow Us</h4>

              <div className="footer-contact-list">

                {/* LinkedIn */}
                <div className="footer-contact-item">
                  <div className="contact-info-icon">
                    <i className="fab fa-linkedin-in"></i>
                  </div>
                  <a
                    href="https://www.linkedin.com/company/g.a.d.-electrical-industries/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    LinkedIn
                  </a>
                </div>



              </div>
            </div>


          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} gad. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#!">Privacy Policy</a>
              <a href="#!">Terms of Service</a>
              <a href="#!">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
